<template>
  <div class="mii-table" :class="{'mii-table-1': tableStyle && tableStyle.all === 1, 'mii-table-2': !tableStyle || tableStyle.all === 2, 'mii-table-3': !tableStyle || [1, 2].indexOf(tableStyle.all) === -1}">
    <table :class="{'table-style-1': tableStyle && tableStyle.table === 1, 'table-style-2': tableStyle && tableStyle.table === 2, 'table-style-3': !tableStyle || [1, 2].indexOf(tableStyle.table) === 01, 'scroll-table': tableStyle && tableStyle.scroll === 1}" v-if="tableData.length > 0">
      <thead>
        <tr>
          <th v-if="showCheckbox"><el-checkbox v-model="checkedAll"></el-checkbox></th>
          <th v-for="column in columns" @click="sortData(column.key)">{{column.label}}</th>
          <th v-if="tableAction && tableAction.length > 0">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, index) in tableData" @click="clickRow(data)">
          <td v-if="showCheckbox"><el-checkbox v-model="data.checked"></el-checkbox></td>
          <td :rowspan="(data[column.key] || {}).rowspan || 1" v-for="column in columns" :class="{'difference-row': !(data[column.key] || {}).label && (index % 2 === 0), 'tb-td': s_key && s_key.indexOf(column.key) > -1}"  :style="column.style ? column.style(data[column.key]) : {}" v-if="(data[column.key] || {}).rowspan !== 0">{{(data[column.key] || {}).label || data[column.key]}}</td>
          <td v-if="tableAction && tableAction.length > 0" class="table-action">
            <a href="javascript:;" v-for="table_action in tableAction" v-if="!table_action.show || table_action.show(data)" @click.stop="clickTdBtn(data, table_action.key)">{{table_action.label}}</a>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="t-tfoot" v-if="pageParm">
      <el-pagination small @size-change="handleSizeChange" :layout="!pageParm.pageSizeChangeList || pageParm.pageSizeChangeList.length === 0 ? 'prev, pager, next' : 'sizes, prev, pager, next'" v-on:current-change="pageChange" :page-size="pageParm.row_num" :total="pageParm.tablePagination ? datas.length : pageParm.dataTotal" :page-sizes="pageParm.pageSizeChangeList || []">
      </el-pagination>
    </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  listToTableData,
  clSortDatas,
  mapCp
} from '@/cllib'
export default {
  data () {
    return {
      checkedAll: false,
      checkedData: [],
      shortKey: '',
      shortOrderMax: true,
      currentPage: 0
    }
  },
  props: ['datas', 'columns', 'tableStyle', 'pageParm', 'tableAction', 'checkboxParm', 'mergeRowKeyList', 'listTable', 's_key'],
  computed: {
    tableData: {
      get () {
        let vm = this
        let data = []
        let showDatas = this.pageParm && this.pageParm.tablePagination ? this.datas.slice(this.currentPage * this.pageParm.row_num, (this.currentPage + 1) * this.pageParm.row_num) : this.datas
        // tablePagination 为true 传出完整数据, 为false，传入分页后数据
        showDatas.forEach(function (item) {
          data.push(mapCp(item))
        })
        if (this.mergeRowKeyList && this.mergeRowKeyList.length > 0) {
          // 列合并
          data = this.listTable ? data : listToTableData(data, this.mergeRowKeyList)
        } else if (this.shortKey) {
          // 点击表头排序
          data = clSortDatas(data, function (a, b) {
            return vm.shortOrderMax ? Number(a[vm.shortKey]) > Number(b[vm.shortKey]) : Number(a[vm.shortKey]) < Number(b[vm.shortKey])
          })
        }
        return data
      }
    },
    showCheckbox: {
      get () {
        return this.checkboxParm && true
      }
    }
  },
  methods: {
    handleSizeChange (pageSize) {
      this.$emit('pageSizeChange', pageSize)
    },
    pageChange (currentPage) {
      if (this.pageParm && this.pageParm.tablePagination) {
        this.currentPage = currentPage - 1
      } else {
        this.$emit('pageChange', currentPage)
      }
    },
    clickRow (data) {
      this.$emit('click_row', data)
    },
    sortData (key) {
      this.shortKey = key
      this.shortOrderMax = !this.shortOrderMax
    },
    clickTdBtn (data, key) {
      this.$emit('clickTdBtn', {data, key})
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
.tb-td {
  background-color: rgb(253, 227, 167) !important;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table-2 {
  background-color: @bak-color-td-1;
}
.mii-table-3 {
  background-color: #fff;
}
.table-style-2 {
}
.table-style-1 {
}
.table-style-3 {
  .difference-row {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
}
.t-tfoot {
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 0.2em 0;
}
table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
      height: 2em;
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    td {
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis; 
      height: 2.5em;
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      color: @bak-color-1;
    }
  }

</style>

<style lang="less">
.mii-table{
  .icon-jiantou {
    font-weight: 600;
    padding: 0 0.2em;
  }
  .el-pagination button {
    background-color: rgba(0, 0, 0, 0);
  }
  .el-pager li {
    background-color: rgba(0, 0, 0, 0);
  }
  .el-pager li.active {
    background-color: #20a0ff;
  }
}
</style>



// WEBPACK FOOTER //
// MiiTableOil.vue?541fe4c6